import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'CashCollectionReport/Select');
};

export const SelectByUserID = async (request) => {
    return PostAPI(request, 'CashCollectionReport/SelectByUserID');
};

export const Add = async (request) => {
    return PostAPI(request, 'CashCollection/Add');
};
export const Reverse = async (request) => {
    return PostAPI(request, 'CashCollection/Reverse');
};
export const SendCollectionMessage = async (request) => {
    return PostAPI(request, 'CashCollection/SendCollectionMessage');
};
export const SelectByFilter = async (request) => {
    return PostAPI(request, 'CashCollectionDetail/SelectByFilter');
};
export const OutstandingReport = async (request) => {
    return PostAPI(request, 'CashCollection/OutstandingReport');
};
export const GetTotalOutstandingBalance = async (request) => {
    return PostAPI(request, 'CashCollection/GetTotalOutstandingBalance');
};
